import * as React from 'react';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import FormatPaintIcon from '@mui/icons-material/FormatPaint';
import AccessibilityNewIcon from '@mui/icons-material/AccessibilityNew';
import MovingIcon from '@mui/icons-material/Moving';
import InfoCard from '../InfoCard';

const featuredItems = [
  {
    title: 'Customizable and flexible',
    description:
      'Easily adapt the look, feel, and behavior to fit any brand—no matter your use case.',
    icon: <FormatPaintIcon fontSize="small" color="primary" />,
  },
  {
    title: 'Inclusive by design',
    description:
      'Built to meet accessibility standards, ensuring a seamless experience for every user.',
    icon: <AccessibilityNewIcon fontSize="small" color="primary" />,
  },
  {
    title: 'Performant and scalable',
    description:
      'Leverage features like virtualization and lazy loading to deliver lightning-fast performance at any scale.',
    icon: <MovingIcon fontSize="small" color="primary" />,
  },
];

export default function TreeViewFeaturesHighlight() {
  return (
    <React.Fragment>
      <Divider />
      <Stack spacing={4} sx={{ py: 8, alignItems: 'center' }}>
        <Stack spacing={1} sx={{ maxWidth: { xs: '500px', md: '100%' } }}>
          <Typography
            variant="body2"
            color="primary"
            sx={{ fontWeight: 'semiBold', textAlign: 'center' }}
          >
            Using the MUI X Tree View
          </Typography>
          <Typography
            variant="h4"
            component="h2"
            sx={{ fontWeight: 'semiBold', color: 'text.primary', textAlign: 'center' }}
          >
            Create stunning tree structures
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary', textAlign: 'center' }}>
            A highly performant, customizable React component with best-in-class developer
            experience.
          </Typography>
        </Stack>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={2}
          sx={{ maxWidth: { xs: '500px', md: '100%' } }}
        >
          {featuredItems.map(({ title, description, icon }, index) => (
            <Box sx={{ flexBasis: '33%' }} key={index}>
              <InfoCard
                title={title}
                description={description}
                icon={icon}
                backgroundColor="subtle"
              />
            </Box>
          ))}
        </Stack>
      </Stack>
    </React.Fragment>
  );
}
